module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-3@3x-b2b481b4c5a4f0be4088e41e813f7325.png";